// extracted by mini-css-extract-plugin
module.exports = {"root":"template-icon-with-text_root__3Q9U-"};